import { Injectable } from '@angular/core';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import { GetRolesUsuarioLoginResponse } from '../usuario/domain/user-entity';
import { ListarRolesUsuarioRequest } from '../gestion-usuario/domain/request/gestion-usuario-request';
import { GestionUsuarioRepository } from '../gestion-usuario/domain/gestion-usuario-repository';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class RolesSesionService {
  // BehaviorSubject para mantener la lista de roles en la sesión
  private rolesSubject = new BehaviorSubject<GetRolesUsuarioLoginResponse[] | null>(null);

  // Observable público para que otros componentes se suscriban a los cambios
  public roles$: Observable<GetRolesUsuarioLoginResponse[] | null> = this.rolesSubject.asObservable();

  constructor(
    private readonly usuariosService: GestionUsuarioRepository,
    public storage: StorageService,
  ) { 
    this.cargarRoles();
  }

  /**
   * Almacena la lista de roles y la emite a todos los suscriptores.
   * @param roles La lista de roles obtenida durante el login.
   */
  setRoles(roles: GetRolesUsuarioLoginResponse[]): void {
    this.rolesSubject.next(roles);
  }

  /**
   * Obtiene la lista de roles actual (el valor más reciente).
   * @returns La lista de roles o null.
   */
  getRoles(): GetRolesUsuarioLoginResponse[] | null {
    return this.rolesSubject.getValue();
  }

  /**
   * Limpia el estado de la sesión (ej. al cerrar sesión).
   */
  clearSessionState(): void {
    this.rolesSubject.next(null);
  }

  async cargarRoles(): Promise<void> {
    const rolesEnSesion = this.getRoles();

    if (rolesEnSesion && rolesEnSesion.length > 0) {
      this.setRoles(rolesEnSesion);
      console.log('Roles inicializados en sesión:', rolesEnSesion);
      return;
    }

    try {
      const request = <ListarRolesUsuarioRequest>{};
      request.usuario = this.storage.get('usuario')

      const res = await firstValueFrom(
        this.usuariosService.listarRolesByUsr(request)
      );

      if (res.datos.status === 200) {
        var datos = res.datos.result;
        this.setRoles(datos);
        console.log('Roles actualizados en sesión:', datos);
      }
    } catch (err) {
      console.error(err);
    }
  }

}